module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subject"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Aktivasi Organisasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-blue"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.ossTemplate,
      "download": ""
    }
  }, [_vm._v("\n            Download "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-blue"
  }, [_c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Bulk Activation / Registration Upload .CSV")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Upload "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Download Example csv")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cae30c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/organizations/OrganizationsActivation.vue
// module id = 1360
// module chunks = 0